import script from "./ForgotPasswordPageXL.vue?vue&type=script&setup=true&lang=js"
export * from "./ForgotPasswordPageXL.vue?vue&type=script&setup=true&lang=js"

import "./ForgotPasswordPageXL.vue?vue&type=style&index=0&id=4d60affe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d60affe"]])

export default __exports__